import React, { useEffect, useState } from "react";
import { Stack, CircularProgress } from "@mui/material";
import { DamsColors } from "../../components/styles/DamsColors";
import useQueryParam from "../../hooks/useQueryParam";
import { SimpleLabel } from "../../components/Label/SimpleLabel";

import useAppNavigation from '../../hooks/useAppNavigation';
import { AuthApi } from "../../services/auth";
import { PageActions } from "../../config/types";
import { usePageModels } from "../../hooks/usePageActions";
import { DamsAppAsset } from "../../assets/registry";
import ActionModal from "../../components/Modals/ActionModal";

const Verification: React.FC = () => {
  const token = useQueryParam("token");
  const appNavigation=useAppNavigation()
  const goLoginPage=()=>appNavigation({path:'/auth',isSibling:true})
  const [pageAction, updatePageAction] = useState<PageActions>();
  const { models, openModel } = usePageModels();
  const [isProcessing, toggleProcess] = useState(false);

  useEffect(() => {
    if (!token) {
      return;
    }
    setTimeout(() => {
      if(!token) {
        goLoginPage();
      }
    },2000)

    const verifyAccount = async () => {
    toggleProcess(true)
    const response= await AuthApi.verifyUser(token);
    toggleProcess(false);
    updatePageAction({
        type:'add',
        title:"Account verification",
        success: response.success,
        message: response.message,
        name:response?.data?.email,
      })
      openModel("alert")
    };
    verifyAccount();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
  
  function toggleAlertModal() {
    if (pageAction?.success) {
      appNavigation({path:'create-password',isSibling:true,options:{state:{email:pageAction.name}}})
    } else {
      goLoginPage();
    }
  }
  return (
    <Stack
      alignContent={"center"}
      justifyContent={"center"}
      height={100}
    >
      {isProcessing && <CircularProgress size={32} sx={styles.spinner} />}
      {pageAction?.success && <SimpleLabel title={pageAction.message} />}
      <ActionModal
              show={models.showAlertModel}
              title={pageAction?.title ?? ""}
              leftIcon={
                pageAction?.success === false
                  ? DamsAppAsset.icons.warning
                  : undefined
              }
              subtitle={pageAction?.message ?? ""}
              onLeftBtnPress={toggleAlertModal}
              leftBtnTxt={"close"}
              onRightBtnPress={toggleAlertModal}
              rightBtnTxt={pageAction?.success ?  "Create Password": "Continue" }
              onClosePress={toggleAlertModal}
              isFullScreen
            />
    </Stack>
  );
};

const styles = {
  spinner: {
    color: DamsColors.Authentication.Button,
    alignSelf: "center",
  },
};

export default Verification;
